<template>
    <div class="deal_index_box">
        <!-- 交易帳單 -->
        <div class="deal_title">
            <div>交易密碼<span>》</span>忘記登入密碼</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box">
            <div class="deal_content_title">忘記登入密碼</div>
            <div class="deal_content">
              <!-- 1 -->
              <div class="phone_box" v-show="nextTF">
                <div class="remind_box">
                  <i class="el-icon-warning icon_warning"></i>
                  簡訊驗證碼將發送到綁定的手機（{{phone}}），收到驗證碼後請填入下方欄位。
                  <span :class="phoneTF ? 'btn_y ggg' : 'btn_y yyy' " @click="btnFun()" >{{btnText}}</span>
                </div>
                <!-- input -->
                <div class="input_box">
                  <span class="span_div"><span>*</span>簡訊驗證碼：</span>
                  <el-input v-model="phoneVal" maxlength="6" placeholder="請輸入簡訊驗證碼"></el-input>
                  <span class="remind_text" >
										<span v-show="remindTF">
											<i class="el-icon-error"></i>
											{{remind}}
										</span>
                  </span>
                </div>
								<div class="btn_box">
								  <el-button plain @click="forget()">返&nbsp&nbsp&nbsp&nbsp&nbsp回</el-button>
								  <el-button type="primary" @click="verifyFun()">點擊驗證</el-button>
								</div>
              </div>
              <!-- 2 -->
              <div v-show="!nextTF" class="next_box">
                <!-- input -->
                <div class="input_box">
                  <span class="span_div span_next"><span>*</span>新的<span>登入</span>密碼：</span>
                  <el-input v-model="passVal" maxlength="20" minlength="8" show-password placeholder="8-20位數字+字母，不允許數字字母以外任何字元字符"></el-input>
                  <span class="remind_textde" >
                  	<span v-show="passValTF">
                  		<i class="el-icon-error"></i>
                  		{{remindval}}
                  	</span>
                  </span>
								</div>
                <div class="input_box">
                  <span class="span_div span_next"><span>*</span>重複<span>登入</span>密碼：</span>
                  <el-input v-model="passVal2" maxlength="20" minlength="8" show-password placeholder="8-20位數字+字母，不允許數字字母以外任何字元字符"></el-input>
                  <span class="remind_textde" >
                  </span>
								</div>
                <div class="btn_box">
                  <el-button plain @click="forget()">返回</el-button>
                  <el-button type="primary" @click="amendFun()">修改</el-button>
                </div>
              </div>

            </div>
        </div>
        <!-- deal_index_box -->
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'LoginDealIndex',
    data() {
        return {
          // 1-2步驟：
          nextTF: true,
          // 點擊發送驗證碼：
          btnTF: false,
          btnText: '點擊發送驗證碼',
          timeto: 60,
					timetoss:120,
          // 设置60：
          countTime: 60,
          // 驗證碼按鈕：
          phoneTF: false,
          // 驗證碼驗證：
          verificationTF: false,
          phoneVal: '',
          messVal: '',
          remind: '驗證錯誤',
          remindTF: false,
					
          // NEXT:
          passVal: '',
          passVal2: '',
					passValTF:false,
					remindval:'',

        // return
        }
    },
    methods: {
	  loginOut(){
		  // console.log(this.$route.path);
		  this.routeUrl = this.$route.path;
		  axios.get(this.$store.state.axiosLoginOutUrl, {
		    params: {
		        uid: this.$store.state.uid,
		        url: this.routeUrl,
		        aution: 1,
		    }
		  }).then((res) => {
		    // console.log(res.data);
		  })
		  localStorage.clear();
		  this.$router.push("/");
		  // this.$store.commit('changeQuit', '0');
	  },
		
	  // 返回
      forget(){
        this.$router.push(this.rouUrl);
      },
      // 点击验证码：
      btnFun(){
				this.timetoss=120;
        this.verificationFun();
      },
      // 點擊驗證：
      verifyFun(){
        if(this.verificationTF){
					if(this.phoneVal==''){
						this.remindTF = true;
						this.remind = '驗證碼不能為空';
						return
					}
					if(this.timetoss){
						if(this.phoneVal == this.messVal){
						  this.remindTF = false;
						  this.nextTF = false;
						} else {
						  this.remindTF = true;
						  this.remind = '驗證碼錯誤';
						}
						
					}else{
						this.remindTF = true;
						this.remind = '驗證碼已過期';
						return
					}

          
        } else {
            this.remindTF = true;
            this.remind = '請點擊發送驗證碼';
        }
      },
      // 验证码倒计时：
      verificationFun(){
        this.verificationTF = true;
        this.phoneTF = true;
        if(!this.btnTF){
          this.btnTF = true;
          this.remindTF = false;
          this.phoneCliFun();
					this.listtime();
          // 倒計時
          this.btnText = this.timeto + "秒後，可再次發送";
          let count = setInterval(() => {
              this.timeto -= 1;
              this.btnText = this.timeto + "秒後，可再次發送";
              if(this.timeto < 1){
                clearInterval(count);
                this.btnText = '點擊發送驗證碼';
                this.timeto = this.countTime;
                this.btnTF = false;
                this.phoneTF = false;
                return
              }
            },1000);

        }
      },
			// 倒计时2分钟
			listtime(){
				let count = setInterval(() => {
						this.timetoss-=1;
				    if(this.timetoss < 1){
							this.timetoss=0;
				      clearInterval(count);
				      return
				    }
				  },1000);
			},
      // 手机输入：
      phoneCliFun(){
          axios.get(this.$store.state.axiosPhone, {
            params:{
              phone: this.$store.state.telephone,
              type: this.phoneType,
            }
          }).then((res) => {
            if(res.data.status){
              this.messVal = res.data.message;

            } else {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: 'error',
                duration: 1000
              });

            }

          })
          
      },
      // 登入密碼限制密碼數字+英文
      amendFun(){
        if( this.passVal&&this.passVal2 ){
          let pattern =/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{8,20}$/;
          // 正則判斷：
          if( pattern.test(this.passVal) ){
            // 判斷是否重複：
            if( this.passVal == this.passVal2 ){
              // console.log('OK');
              this.amendAxFun();
            } else {
              // 
							this.passValTF = true;
							this.remindval = '兩次輸入的登入密碼不壹致';
              // this.$message({
              //   showClose: true,
              //   message: '登入密碼不相同',
              //   type: 'error',
              //   duration: 1000
              // });
            }

          } else {
            // 
						this.passValTF = true;
						this.remindval = '輸入格式錯誤，請重新輸入';
            // this.$message({
            //   showClose: true,
            //   message: '8-20位數字+字母，不允許數字字母以外任何字元字符',
            //   type: 'error',
            //   duration: 1000
            // });
          }

        } else {
          this.passValTF = true;
          this.remindval = '登入密碼不能為空';
          // this.$message({
          //   showClose: true,
          //   message: '登入密碼不能為空',
          //   type: 'error',
          //   duration: 1000
          // });
        }
      },
      // axios登入密碼：
      amendAxFun(){
        axios.get(this.$store.state.axiosloginPasswordUrl, {
          params:{
            uid: this.$store.state.uid,
            re_password: this.passVal,
          }
        }).then((res) => {
          if(res.data.status){
              this.$message({
                showClose: true,
                message: res.data.message,
                type: 'success',
                duration: 1000
              });
              this.loginOut();
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'error',
              duration: 1000
            });
          }

        })

      },


    },
    computed: {
      phone(){
        // 前4位，后2位；
        let str = this.$store.state.telephone;
        let strNum = '';
        for(let i=0; i<(str.length - 6); i++){
          strNum += '*';
        }
        // 前4位，后2位；
        str = str.substring(0, 4) + strNum + str.substr(-2);
        return str
      },
      phoneType(){
        let str = this.$store.state.telephone;
        str = str.substring(0, 2);
        if(str == '09'){
          return 'tw'
        } else {
          return 'cn'
        }
      },
      rouUrl(){
        return this.$store.state.FPnumber;
      },
    },
    created() {
      
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        margin: 30px 0;
        display: flex;
        justify-content: flex-start;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .time_box {
        font-size: 17px;
        margin-bottom: 33px;
        letter-spacing: 1px;
    }
    .time_box > span {
        color: #e73262;
        margin: 0 5px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 38px 20px;
        padding-top: 26px;
    }
    /* 1 */
    .remind_box {
      display: flex;
      justify-content: center;
      background: #fff4cc;
      padding: 20px 0;
      display: flex;
      align-items: center;
      font-size: 17px;
    }
	  .icon_warning {
      font-size: 22px;
      color: #ff4a05;
      padding: 0 6px 0 24px;
    }
    .remind_text {
			width: 200px;
      color: #e73262;
      margin-left: 20px;
    }
		.remind_textde{
			width: 240px;
			color: #e73262;
			margin-left: 20px;
		}
    .btn_y {
      color: white;
      padding: 4px 16px;
      border-radius: 6px;
      margin-left: 20px;
      cursor: pointer;
      width: 160px;
      text-align: center;
    }
    .yyy {
      background: #ff7813;
    }
    .ggg {
      background: #666666;
    }
    .input_box {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 17px;
      margin-top: 60px;
    }
    .mar20 {
      margin-top: 20px;
    }
    .span_div {
      width: 120px;
    }
    .span_div >span {
      color: #e73262;
    }
    .span_next {
      width: 140px;
    }
    .input_box .el-input {
      width: 400px;
    }
    .input_box .el-button {
      margin-left: 20px;
    }
    /* next */
    .next_box .input_box {
      margin: 20px 0px;
    }
    .btn_box {
      display: flex;
      justify-content: center;
      margin-top: 40px;
    }


</style>
